import type { ReactNode } from 'react';
import type { VotesOg } from '@/types';
import { VoteLayout } from './components/VoteLayout';

export default function Og({
  edition,
  projects,
  tileSize,
  deadline,
  boldDeadline,
}: VotesOg) {
  return (
    <div className="theme-ph26 flex min-h-screen items-center justify-center bg-background p-8">
      <div
        className="relative flex overflow-hidden border border-primary/20 bg-background"
        style={{ width: '1200px', height: '630px' }}
      >
        <div
          className="flex h-full w-[600px] shrink-0 items-center justify-center p-6"
          style={{ perspective: '1400px' }}
        >
          <div
            className="grid grid-cols-5 gap-3"
            style={{
              transform: 'rotateY(-12deg) rotateX(6deg) rotateZ(-2deg)',
              transformStyle: 'preserve-3d',
            }}
          >
            {projects.map((project) => (
              <div
                key={project.id}
                className="flex aspect-square items-center justify-center overflow-hidden rounded-md border border-primary/20 bg-background"
                style={{
                  width: `${tileSize}px`,
                  height: `${tileSize}px`,
                  transform: 'translateZ(18px)',
                  boxShadow:
                    '0 14px 22px rgba(0,0,0,0.55), 0 4px 8px rgba(0,0,0,0.35), inset 0 1px 0 rgba(242,255,0,0.08)',
                }}
              >
                {project.logoUrl ? (
                  <img
                    src={project.logoUrl}
                    alt={project.name}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <span className="font-title text-primary text-xs uppercase">
                    {project.name.slice(0, 4)}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-1 flex-col justify-center gap-10 pr-16 pl-8">
          <div className="flex flex-col gap-4">
            <h1 className="whitespace-nowrap font-logo text-[52px] lowercase leading-none tracking-tighter">
              <span className="font-light text-primary">platanus hack</span>{' '}
              <span className="font-medium text-primary">[26]</span>
            </h1>
            <div className="inline-flex w-fit bg-primary px-3 py-1">
              <span className="font-logo text-[56px] text-background lowercase leading-none tracking-tighter">
                voting
              </span>
            </div>
            <p
              className="font-sans text-base text-primary uppercase"
              style={{ letterSpacing: '0.4em' }}
            >
              {edition.city}
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <p className="font-title text-2xl text-primary uppercase tracking-[0.12em]">
              vota hasta el
            </p>
            <p
              className={`${boldDeadline ? 'font-bold ' : ''}font-title text-4xl text-primary uppercase tracking-[0.08em]`}
            >
              {deadline}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

Og.layout = (page: ReactNode) => <VoteLayout>{page}</VoteLayout>;
